module.exports = __webpack_public_path__ + "static/Gameplay_DarkEnchantress-01d2dbb322fd667816dad561fb93bec0.png";